function arrayToPoints(numbers) {
    const result = [];
    for (let i = 0; i < numbers.length - 2; i += 3) {
      result.push({
        x: numbers[i],
        y: numbers[i + 1]
      });
    }
    return result;
  }
  
export const isPointInPolygon=(address, cities) => {
    if(!address|| !cities){
        return false;
    }
    const polygon = arrayToPoints(cities)

    const x = address.position.lat, y = address.position.lng;
    let inside = false;
    
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i].x, yi = polygon[i].y;
      const xj = polygon[j].x, yj = polygon[j].y;
      
      const intersect = ((yi > y) !== (yj > y)) &&
        (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    
    return inside;
  }